import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

export const usePreRegisterGiftSimDalefon = ({
  preRegisterGiftSimDalefonAction,
  preRegisterGiftSimDalefon,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [processCompleted, setProcessCompleted] = useState(false);

  useEffect(() => {
    if (preRegisterGiftSimDalefon?.status === 200) {
      setLoading(false);
    } else if (preRegisterGiftSimDalefon?.payload?.response?.status > 200) {
      setDialogMessage(preRegisterGiftSimDalefon?.payload?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [preRegisterGiftSimDalefon]);

  const onSubmit = async (csvFile, productId) => {
    setLoading(true);
    try {
      await preRegisterGiftSimDalefonAction(csvFile, productId);
      setDialogMessage('Pre registro completado exitosamente!');
      setIsDialogOpen(true);
      setErrorMessage('');
      setProcessCompleted(true);
    } catch (e) {
      const responseError = e.response?.data;
      setErrorMessage('Ocurrió un error en el pre registro.');
      setDialogMessage(`Error al realizar el pre registro: ${responseError?.detail}  `);
      setIsDialogOpen(true);
    }
    setLoading(false);
  };

  const handleClose = () => {
    if (isDialogOpen) {
      setIsDialogOpen(false);
    } else {
      setIsDialogOpen(false);
    }
  };

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    errorMessage,
    setErrorMessage,
    processCompleted,
    setProcessCompleted,
  };
};
